/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Application } from '@carbon/react/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TabContent } from '../../common/tabbed-header/TabContent';
import { NewPage as messages } from './messages';

export const CatalogOpenApiSplashPage = () => {
  // Need to wrap the Image so it will be in color and work with TabContent
  const WrappedImageComponent = () => {
    return <Application size={32} />;
  };

  return (
    <div className="CatalogOpenApi__NewPage">
      <TabContent
        title={<FormattedMessage {...messages.title} />}
        ImageComponent={WrappedImageComponent}>
        <div className="TabContent__body-content">
          <div className="TabContent__subtitle">
            <FormattedMessage {...messages.subtitle} />
          </div>
        </div>
      </TabContent>
    </div>
  );
};
